// extracted by mini-css-extract-plugin
module.exports = {"buttonCounters":"counter_buttonCounters__A6X6c","text":"counter_text__34bZL","decrement":"counter_decrement__2wjMy","increment":"counter_increment__21Lrt"};